export default function toFloat(myString) {
  if(myString === "")
  {
    return 0.0;
  }
  else{
  return parseFloat(myString);
  }
}